<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="queryParams.name"
          class="!w-240px"
          clearable
          placeholder="请输入名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="国家" prop="country">
        <el-input
          v-model="queryParams.country"
          class="!w-240px"
          clearable
          placeholder="请输入国家"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          :model-value="queryParams.status as any"
          @update:model-value="(val: any) => queryParams.status = val"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:brand-group:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="名称" prop="name" min-width="180">
        <template #default="scope">
          <el-tag type="info">{{ scope.row.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="编码" prop="code">
        <template #default="scope">
          <el-tag type="success">{{ scope.row.code }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Logo" prop="logo" width="100">
        <template #default="scope">
          <el-image
            v-if="scope.row.logo"
            :src="scope.row.logo"
            style="width: 70px; height: 45px; border-radius: 4px"
            fit="contain"
          />
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="国家" prop="country">
        <template #default="scope">
          <el-tag v-if="scope.row.country">{{ scope.row.country }}</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="网站" prop="website" min-width="150" />
      <el-table-column align="center" label="状态" prop="status">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.COMMON_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序" prop="sort" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:brand-group:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:brand-group:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="编码" prop="code">
        <el-input v-model="formData.code" placeholder="请输入编码" />
      </el-form-item>
      <el-form-item label="Logo" prop="logo">
        <UploadImg
          v-model="formData.logo"
          :width="'180px'"
          :height="'120px'"
          :file-size="5"
          :file-type="['image/jpeg','image/png','image/webp','image/svg+xml']"
          directory="hotel/brand-logo"
        >
          <template #tip>支持 JPG/PNG/WEBP/SVG，≤ 5MB</template>
        </UploadImg>
      </el-form-item>
      <el-form-item label="国家" prop="country">
        <el-input v-model="formData.country" placeholder="请输入国家" />
      </el-form-item>
      <el-form-item label="网站" prop="website">
        <el-input v-model="formData.website" placeholder="请输入网站地址" />
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          v-model="formData.description"
          :rows="3"
          placeholder="请输入描述"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :value="dict.value"
          >
            {{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="formData.sort"
          :min="0"
          placeholder="请输入排序"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import * as brandGroupApi from '@/api/hotel/brandGroup'
import { CommonStatusEnum } from '@/utils/constants'
import UploadImg from '@/components/UploadFile/src/UploadImg.vue'

defineOptions({ name: 'HotelBrandGroup' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  name: undefined,
  country: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await brandGroupApi.getBrandGroupPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<brandGroupApi.BrandGroupVO>({
  id: 0,
  name: '',
  code: '',
  logo: undefined,
  country: '',
  website: '',
  description: '',
  status: CommonStatusEnum.ENABLE,
  sort: 0,
  createTime: undefined as any
})
const formRules = reactive({
  name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await brandGroupApi.getBrandGroup(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await brandGroupApi.createBrandGroup(data)
      message.success(t('common.createSuccess'))
    } else {
      await brandGroupApi.updateBrandGroup(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: 0,
    name: '',
    code: '',
    logo: undefined,
    country: '',
    website: '',
    description: '',
    status: CommonStatusEnum.ENABLE,
    sort: 0,
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await brandGroupApi.deleteBrandGroup(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
})
</script>
